module.exports = __webpack_public_path__ + "img/ms_logo.363fdd53.svg";